import { render, staticRenderFns } from "./DialogImportGroupTeacher.vue?vue&type=template&id=07debddc&scoped=true"
import script from "./DialogImportGroupTeacher.vue?vue&type=script&lang=js"
export * from "./DialogImportGroupTeacher.vue?vue&type=script&lang=js"
import style0 from "./DialogImportGroupTeacher.vue?vue&type=style&index=0&id=07debddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07debddc",
  null
  
)

export default component.exports